export default __webpack_public_path__ + "static/media/peizhenRectangle.bfa011bc.jpg";